"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Body_1 = require("../Core/Body");
require("selectric/src/jquery.selectric");
exports.Sort = function () {
  var Selector = {
    SELECT_SORT_BY: "#srt_2",
    SELECT_ON_PAGE: "#srt_1",
    FORM: "#filter-form"
  };
  function initCustomSelects() {
    $(Selector.SELECT_SORT_BY).selectric();
    $(Selector.SELECT_ON_PAGE).selectric();
  }
  function applySortingValuesAfterSelect() {
    $(this).addClass('js_active_to_submit');
    $(Selector.FORM).submit();
  }
  Body_1.$body.ready(initCustomSelects);
  Body_1.$body.on('change', Selector.SELECT_ON_PAGE, applySortingValuesAfterSelect);
  Body_1.$body.on('change', Selector.SELECT_SORT_BY, applySortingValuesAfterSelect);
}();